export default __webpack_public_path__ + "83a9d187bfa7b54bb9764a9cfbc287a2.png";